exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PlayerLineup__column--28j71 {\n  padding: 0 8px;\n  margin-top: 20px;\n}\n\n.PlayerLineup__players--2WMbl {\n  padding-top: 5px;\n}\n\n.PlayerLineup__players--2WMbl > span:last-child div {\n  border-bottom: 0;\n}\n\n.PlayerLineup__title--3SO9Q {\n  font-weight: 500;\n  font-size: 20px;\n}\n\n.PlayerLineup__subTitle--164FS {\n  font-size: 16px;\n  margin-top: 20px;\n  font-weight: 500;\n  padding-top: 5px;\n}\n\n@media (max-width: 768px) {\n  .PlayerLineup__container--1mBrG {\n    margin: 0 auto;\n    padding: 0 10px;\n  }\n  .PlayerLineup__column--28j71 {\n    padding: 0;\n  }\n  .PlayerLineup__title--3SO9Q {\n    font-size: 16px;\n  }\n}", ""]);

// exports
exports.locals = {
	"column": "PlayerLineup__column--28j71",
	"players": "PlayerLineup__players--2WMbl",
	"title": "PlayerLineup__title--3SO9Q",
	"subTitle": "PlayerLineup__subTitle--164FS",
	"container": "PlayerLineup__container--1mBrG"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };